import isMobile from "is-mobile";

export default {
  computed: {
    // All Components now have an isMobile properties
    isMobile() {
      return isMobile({ tablet: true });
    },
  },
};
